import React, { useState, useEffect } from "react";
import { RxHamburgerMenu } from "react-icons/rx";
import { MdOutlineClose } from "react-icons/md";
import { useLocation } from "react-router-dom";
import Logo from "../images/atmospheric/logo.png";
const Navbar = () => {
  let Links = [
    { name: "דף הבית", link: "/" },
    { name: "עיצוב גרפי מיתוג ופרסום", link: "/Branding" },
    { name: "דפוס דיגיטלי", link: "/Print" },
    { name: "סרטוני בינה מלאכותית לעסקים", link: "/AIVideo" },
    { name: "עריכת וידאו", link: "/VideoEditing" },
    { name: "יצירת קשר", link: "/Contact" },
  ];
  let [open, setOpen] = useState(false);
  const [isTop, setIsTop] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      // Check if the scroll position is at the top of the page
      setIsTop(window.scrollY === 0);
    };

    // Add scroll event listener
    window.addEventListener("scroll", handleScroll);

    // Clean up the event listener
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const location = useLocation();

  return (
    <div
      className={`navbar w-full fixed top-0 left-0 ${
        isTop
          ? "bg-transparent"
          : "bg-black/70 shadow-[0_4px_30px_rgba(0,0,0,0.5)] backdrop-blur-xl border-b border-white/10"
      } text-white z-[1000] transition-all duration-500`}
    >
      <div
        className={`md:flex items-center justify-between py-4 md:px-10 px-7 transition-colors duration-500 ${
          isTop
            ? "bg-gradient-to-b from-black/80 to-transparent"
            : "bg-transparent"
        }`}
      >
        <div className="font-bold text-2xl cursor-pointer text-main flex items-center gap-1">
          <img src={Logo} className="w-36 md:w-44" alt="" />
        </div>
        <div
          onClick={() => setOpen(!open)}
          className="absolute right-8 top-6 cursor-pointer md:hidden flex items-center w-7 h-16"
        >
          {open ? (
            <MdOutlineClose color="white" size={20} />
          ) : (
            <RxHamburgerMenu color="white" size={20} />
          )}
        </div>
        <ul
          className={`md:flex mt-32 md:mt-0 text-right md:flex-row-reverse md:items-center md:pb-0 ${
            isTop && !open ? "bg-transparent" : "bg-black/90 backdrop-blur-xl"
          } md:bg-none md:h-auto h-[80vh] absolute md:static md:z-auto z-[-1] left-0 w-full md:w-auto md:pl-0 pl-9 top-0 transition-all duration-500 ease-in-out ${
            open ? "translate-y-0 opacity-100 border-b border-white/10 shadow-2xl" : "-translate-y-full opacity-0 pointer-events-none md:pointer-events-auto md:translate-y-0 md:opacity-100"
          }`}
        >
          {Links.map((link, index) => (
            <li key={index} className="md:my-0 mr-8 mt-12 md:mt-0 text-center">
              <a
                href={link.link}
                className={`relative text-mainColor text-[1.1rem] font-medium tracking-wide hover:text-orange-400 transition-all duration-300 before:content-[''] before:absolute before:-bottom-1.5 before:right-0 before:w-0 before:h-[2px] before:bg-gradient-to-l before:from-[#c44200] before:to-[#f07800] hover:before:w-full before:transition-all before:duration-300 py-1 ${
                  location.pathname === link.link
                    ? "gold-text before:w-full"
                    : ""
                }`}
              >
                {link.name}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Navbar;
